import "./_carteFournisseur.scss";

import {ReactElement} from "react";

import {carteFournisseur} from "@/types/fournisseur";

function CarteFournisseur({
  fournisseur,
  onClick,
}: {
  fournisseur: carteFournisseur;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}): ReactElement {
  return (
    <div className="carteFournisseur" onClick={onClick}>
      <p className="carteFournisseur-id">{`# ${fournisseur.id} / ${fournisseur.cofaqId}`}</p>
      <img
        src={fournisseur.logo}
        alt={`Logo du fournisseur ${fournisseur.libelle}`}
        loading="lazy"
      />
      <p className="carteFournisseur-libelle">{fournisseur.libelle}</p>
    </div>
  );
}

export default CarteFournisseur;
